import React from 'react';
import styles from './Vote.module.css';
import { motion } from 'framer-motion';
import Advt from '../Advt/Advt';

const Vote = ({
  variants,
  title,
  currentState,
  answerFontSize,
  questionFontSize,
}) => {
  return (
    <div className={styles.wrapper}>
      {currentState === 'S2' && (
        <div className={styles.questionBlock}>
          <motion.div
            key="title"
            initial={{ scale: 0, transformOrigin: 'bottom', y: '10rem' }}
            animate={{ scale: [0, 1.1, 1], y: ['10rem', '-1rem', '0rem'] }}
            transition={{ duration: 0.75, times: [0, 0.8, 1], delay: 0.25 }}
            className={styles.question}
            style={{ fontSize: `${questionFontSize}rem` }}>
            {title}
          </motion.div>
          <div className={styles.answerBlock}>
            {variants.map((el, i) => (
              <motion.div
                initial={{ scale: 0, transformOrigin: 'left' }}
                animate={{
                  scale: [0, 1.1, 1],
                }}
                transition={{
                  duration: 0.75,
                  times: [0, 0.8, 1],
                  delay: 1 + i * 0.75,
                }}
                key={el.comment}
                className={styles.answerItem}
                style={{ fontSize: `${answerFontSize}rem` }}>
                {el.comment}
              </motion.div>
            ))}
          </div>
        </div>
      )}
      {currentState === 'S3' && (
        <div className={styles.questionBlock}>
          <div
            className={styles.question}
            style={{ fontSize: `${questionFontSize}rem` }}>
            {title}
          </div>
          <div className={styles.answerBlock}>
            {variants.map((el, i) => {
              if (el.correct) {
                return (
                  <motion.div
                    style={{ fontSize: `${answerFontSize}rem` }}
                    initial={{ opacity: 1 }}
                    animate={{ opacity: [1, 0, 1, 0, 1] }}
                    transition={{
                      duration: 1,
                      delay: 1.7,
                      times: [0, 0.25, 0.5, 0.75, 1],
                    }}
                    key={el.comment}
                    className={styles.answerItem}>
                    {el.comment}
                  </motion.div>
                );
              } else
                return (
                  <motion.div
                    style={{ fontSize: `${answerFontSize}rem` }}
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 0.1 }}
                    transition={{
                      duration: 1,
                      delay: 0.5,
                    }}
                    key={el.comment}
                    className={styles.answerItem}>
                    {el.comment}
                  </motion.div>
                );
            })}
          </div>
        </div>
      )}
      <div
        className={styles.advtWrapper}
        style={{ marginTop: currentState === 'S1' ? '50rem' : 0 }}>
        <Advt />
      </div>
    </div>
  );
};

export default React.memo(Vote);
